import { SOCKET_EVENTS } from '../constants/socketEvents';
import { getMessageIdentityKeys } from '../../utils/messageDedup';
import { normalizeInterveneSocketPayload } from '../parseIntervenePayload';

function enrichSocketData(normalized) {
  const rawData = normalized?.data || {};
  const meta = normalized?.meta || normalized?.raw?.meta || {};

  const unwrappedData =
    rawData.message && typeof rawData.message === 'object'
      ? { ...rawData.message, ...rawData }
      : rawData.message_data && typeof rawData.message_data === 'object'
        ? { ...rawData.message_data, ...rawData }
        : rawData;

  const phone =
    unwrappedData.phone_number ||
    unwrappedData.phone ||
    unwrappedData.user_phone ||
    unwrappedData.destination_number ||
    unwrappedData.destination ||
    unwrappedData.to ||
    meta.phone_number ||
    meta.phone ||
    normalized?.raw?.phone_number ||
    normalized?.raw?.destination;

  const bot =
    unwrappedData.bot_number ||
    unwrappedData.botNumber ||
    unwrappedData.channel_number ||
    meta.bot_number ||
    meta.botNumber ||
    normalized?.raw?.bot_number ||
    normalized?.raw?.botNumber;

  return {
    ...unwrappedData,
    ...(phone !== undefined ? { phone_number: phone } : {}),
    ...(bot !== undefined ? { bot_number: bot } : {}),
  };
}

function trimProcessedSet(processedSet, maxSize = 500) {
  if (processedSet.size <= maxSize) return;
  const iterator = processedSet.values();
  processedSet.delete(iterator.next().value);
}

export function createInterveneSocketRouter(handlers) {
  const processedEventIds = new Set();
  const processedMessageIds = new Set();

  return function routeInterveneSocketPayload(rawPayload) {
    const normalized = normalizeInterveneSocketPayload(rawPayload);
    if (!normalized) return;

    if (normalized.eventId) {
      if (processedEventIds.has(normalized.eventId)) return;
      processedEventIds.add(normalized.eventId);
      trimProcessedSet(processedEventIds);
    }

    const enrichedData = enrichSocketData(normalized);

    if (normalized.type === SOCKET_EVENTS.CHAT_MESSAGE) {
      const identityKeys = getMessageIdentityKeys(enrichedData);
      if (identityKeys.some((key) => processedMessageIds.has(key))) {
        return;
      }
      identityKeys.forEach((key) => processedMessageIds.add(key));
      trimProcessedSet(processedMessageIds);
    }

    switch (normalized.type) {
      case SOCKET_EVENTS.CHAT_MESSAGE:
        handlers.onChatMessage?.(enrichedData);
        handlers.onListUpdated?.(enrichedData);
        break;
      case SOCKET_EVENTS.SESSION_UPDATED:
        handlers.onSessionUpdated?.(enrichedData);
        handlers.onListUpdated?.(enrichedData);
        break;
      case SOCKET_EVENTS.LIST_UPDATED:
        handlers.onListUpdated?.(enrichedData);
        break;
      case SOCKET_EVENTS.PRESENCE_UPDATED:
        handlers.onPresenceUpdated?.(enrichedData);
        break;
      case SOCKET_EVENTS.COUNTS_UPDATED:
        handlers.onCountsUpdated?.(enrichedData);
        break;
      case SOCKET_EVENTS.MESSAGE_STATUS:
        handlers.onMessageStatus?.(enrichedData);
        break;
      default:
        break;
    }
  };
}
